import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStore } from '@app-auth/data-access/auth.store';
import { BiometricStore } from '@app-auth/data-access/biometric.store';

export const DomainGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const biometricStore = inject(BiometricStore);
  const router = inject(Router);

  if (authStore.isLoggedIn()) return true;

  router.navigate([biometricStore.enabled() ? '/login/biometrics' : '/common/on-boarding']).then();
  return false;
};
